"use client";

import { useState } from "react";
import EmptyState from "./ui/emptyState";
import FoldersGrid from "./grids/foldersGrid/grid";
import FilesGrid from "./grids/filesGrid/grid";
import { useStorageQuery } from "../hooks/storageQueryProvider";

export default function Storage() {
    const [isNoFolders, setIsNoFolders] = useState(false);
    const [isNoFiles, setIsNoFiles] = useState(false);

    const { settings } = useStorageQuery();

    return (
        <>
            {isNoFolders && (!settings.files || isNoFiles) && <EmptyState />}
            <FoldersGrid setIsNoFolders={setIsNoFolders} />
            {settings.files && <FilesGrid setIsNoFiles={setIsNoFiles} />}
        </>
    );
}
